import React from "react";
import { Box, Typography } from "@mui/material";
import PlayerHeadshot from "../PlayerHeadshot";
import { formatPlayerName } from "../../utils/textUtils";

const PlayerPickRow = ({ player, meta, sport = "mlb", onClick }) => {
  const name = formatPlayerName(player);

  return (
    <Box
      onClick={() => onClick?.(player)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 1,
        py: 1,
        borderRadius: 1,
        cursor: "pointer",
        "&:hover": { bgcolor: "action.hover" },
      }}
    >
      <PlayerHeadshot
        playerId={player.playerId}
        size={40}
        showTooltip={false}
        showLoading={false}
        sport={sport}
      />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography variant="body2" fontWeight={600} noWrap>
          {name}
        </Typography>
        {meta && (
          <Typography variant="caption" color="text.secondary">
            {meta}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PlayerPickRow;
